import { Component, OnInit, HostListener } from '@angular/core';

@Component({
  selector: 'app-information-slider',
  templateUrl: './information-slider.component.html',
  styleUrls: ['./information-slider.component.css']
})
export class InformationSliderComponent implements OnInit {
  newsItems = [
    {
      titlePart1: 'Besoin d\'aide avec', 
      titlePart2: 'Les réclamations bancaires ?', 
      description: ['Notre plateforme est là pour vous aider à résoudre tous vos problèmes bancaires rapidement et efficacement.'], 
      image: '../../assets/image1Landing.png'
    },
    {
      titlePart1: 'RECLABANC aide à faciliter ', 
      titlePart2: 'La résolution des litiges relatifs aux réclamations bancaires', 
      description: ['Nous travaillons avec vous et votre banque pour résoudre les litiges de manière équitable et transparente.', 'Notre équipe d\'experts est à votre disposition pour vous guider à chaque étape.'], 
      image: '../../assets/image2Landing.png'},
    {
      titlePart1: '5 étapes simples ', 
      titlePart2: 'Pour soumettre une réclamation',
      description: [
        'Étape 1: Créez un compte sur notre plateforme.',
        'Étape 2: Connectez-vous et accédez à la section "Soumettre une réclamation".',
        'Étape 3: Remplissez le formulaire de réclamation en fournissant tous les détails nécessaires.',
        'Étape 4: Soumettez votre réclamation et recevez un accusé de réception.',
        'Étape 5: Suivez l\'évolution de votre réclamation via votre tableau de bord.'
      ],
      image: '../../assets/image3Landing.png'
    },
  ];

  activeIndex = 0;
  autoScrollInterval: any;

  ngOnInit() {
    this.startAutoScroll();
  }

  startAutoScroll() {
    this.autoScrollInterval = setInterval(() => {
      this.nextSlide();
    }, 6000);
  }

  firstItem: boolean = true;
  secondItem : boolean = false;
  thirdItem : boolean = false;

  nextSlide() {
    this.activeIndex = (this.activeIndex + 1) % this.newsItems.length;
    if(this.firstItem){
      this.firstItem=!this.firstItem;
      this.secondItem=!this.secondItem;
    }
    else{
      if(this.secondItem){
        this.secondItem=!this.secondItem;
        this.thirdItem=!this.thirdItem;
      }
      else{
        this.thirdItem=!this.thirdItem;
        this.firstItem=!this.firstItem;
      }
    }
  }

  prevSlide() {
    this.activeIndex = (this.activeIndex - 1 + this.newsItems.length) % this.newsItems.length;
  }

  @HostListener('mousewheel', ['$event'])
  onMouseWheel(event: WheelEvent) {
    if (event.deltaY > 0) {
      this.nextSlide();
    } else {
      this.prevSlide();
    }
    clearInterval(this.autoScrollInterval);
    this.startAutoScroll();
  }
}
